@if (onboarding.draft().brand; as brand) {
<div class="flex flex-col gap-4">
  <div class="flex shrink-0 flex-col gap-3">
    <h1 class="use-grotesque m-0 text-4xl font-bold leading-none tracking-tight text-balance sm:text-5xl">
      We found {{ brand.name }} 🎯
    </h1>
    <p class="m-0 text-xl font-semibold leading-snug text-muted-foreground">This is your SHOUT workspace. Confirm your currency,
      then claim it.</p>
  </div>

  <article class="overflow-hidden rounded-xl border border-border bg-card shadow-lg">
    @if (brand.bannerUrl) {
    <img [src]="brand.bannerUrl" alt="" class="h-16 lg:h-24 w-full shrink-0 object-cover" />
    } @else {
    <div class="h-16 shrink-0 bg-linear-to-br from-brand-deep-purple to-primary"></div>
    }
    <div class="flex shrink-0 items-center gap-3 px-5 pt-5">
      <div
        class="flex shrink-0 items-center justify-center overflow-hidden rounded-lg border-4 border-card bg-linear-to-br from-brand-studio-dark to-brand-studio text-xl font-black text-white shadow-sm">
        @if (brand.logoUrl) {
        <img [src]="brand.logoUrl" alt="" class="size-14 rounded-lg object-contain" />
        } @else {
        <div class="flex size-14 items-center justify-center rounded-lg text-xl font-black text-white">
          {{ initial() }}
        </div>
        }
      </div>
      <div class="min-w-0 flex-1">
        <p class="m-0 text-2xl font-semibold text-primary">{{ brand.name }}</p>
        @if (brand.domain) {
        <p class="m-0 text-base text-secondary">{{ brand.domain }}</p>
        }
      </div>
      <button type="button" class="btn-shout-fab-secondary shrink-0" (click)="edit()" aria-label="Edit brand">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          class="size-4" aria-hidden="true">
          <path d="M12 20h9" />
          <path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z" />
        </svg>
      </button>
    </div>

    <div class="flex flex-col gap-3.5 px-5 py-4">
      @if (brand.description) {
      <p #description class="m-0 text-md text-primary" [class]="descriptionClass()">{{ brand.description }}
      </p>
      @if (descriptionOverflows()) {
      <button type="button" class="self-start text-base font-bold text-primary" (click)="toggleDescription()">
        {{ descriptionOpen() ? 'Show less' : 'Show more' }}
      </button>
      }
      }
      <div class="flex flex-wrap gap-2">
        @if (brand.industry) {
        <p class="m-0 rounded-full bg-primary/10 px-3 py-1 text-sm font-bold text-accent">{{ brand.industry
          }}</p>
        }
        @if (brand.socials.length) {
        <p class="m-0 rounded-full bg-primary/10 px-3 py-1 text-sm font-bold text-accent">{{
          brand.socials.length }} social channels</p>
        }
      </div>
      @if (brand.socials.length) {
      <div class="border-t border-border pt-3">
        <p class="m-0 text-base font-bold">Socials and links</p>
        <div class="mt-2 flex flex-wrap gap-2">
          @for (social of brand.socials; track social.url) {
          <a [href]="social.url" [attr.aria-label]="social.type" target="_blank" rel="noopener noreferrer"
            class="inline-flex size-9 items-center justify-center rounded-md border border-border text-lg text-primary">
            <fa-icon [icon]="socialIcon(social.type)" aria-hidden="true" />
          </a>
          }
        </div>
      </div>
      }
    </div>
  </article>

  <fieldset class="m-0 flex shrink-0 flex-col gap-2 border-0 p-0">
    <legend class="text-base font-bold">Campaign currency</legend>
    <div class="grid grid-cols-3 gap-2">
      @for (currency of currencies; track currency) {
      <button type="button" class="h-12 rounded-lg border text-lg font-bold"
        [class]="onboarding.activeCurrency() === currency ? 'border-primary bg-primary text-primary-foreground' : 'border-border bg-card text-foreground'"
        (click)="chooseCurrency(currency)">
        {{ currency === 'GBP' ? '£ GBP' : currency === 'USD' ? '$ USD' : '€ EUR' }}
      </button>
      }
    </div>
    <p class="m-0 text-sm font-semibold text-muted-foreground">
      @if (currencyDetected()) {
        Detected from {{ brand.domain || 'your website' }}. Your campaigns and wallet use this currency.
      } @else {
        Your campaigns and wallet use this currency.
      }
    </p>
  </fieldset>

  <div
    class="fixed inset-x-0 bottom-0 z-20 shrink-0 border-t border-border bg-background px-5 py-3 lg:static lg:z-auto lg:border-t lg:px-0">
    <button type="button" class="btn-shout btn-shout-md btn-shout-primary w-full justify-center" (click)="claim()">
      Claim {{ brand.name }}'s workspace →
    </button>
    <button type="button" class="mt-3 w-full text-center text-base font-bold text-primary" (click)="reject()">This isn't
      my brand</button>
  </div>
</div>
}